import StaffPerformanceHTMLPreviewBaseSection from './StaffPerformanceHTMLPreviewBaseSection'

export default function StaffPerformanceHTMLPreviewLeaveSection() {}

StaffPerformanceHTMLPreviewLeaveSection.prototype = new StaffPerformanceHTMLPreviewBaseSection();

StaffPerformanceHTMLPreviewLeaveSection.prototype.init = function ( columnsStrategy )
{
    StaffPerformanceHTMLPreviewBaseSection.prototype.init.call(this, columnsStrategy);
    return this;
};

StaffPerformanceHTMLPreviewLeaveSection.prototype.addRows = function ( tBody )
{
    this.addRow( tBody, this.makeGrandTotalRow() );
    this.addRow( tBody, this.makeLeaveRow() );
    this.addRow( tBody, this.makeLeaveRow() );
};

StaffPerformanceHTMLPreviewLeaveSection.prototype.makeGrandTotalRow = function ()
{
    return this.createRowWithMainAndDataCells("grandTotal", this.message("report.staffoutput.total_working_leave_time"), "grandTotalCell" );
};

StaffPerformanceHTMLPreviewLeaveSection.prototype.makeLeaveRow = function ()
{
    return this.createRowWithMainAndDataCells("leave", this.message("report.preview.leave_type"), "leaveType");
};


// WEBPACK FOOTER //
// ./web/js/reports/preview/html/staffperformance/StaffPerformanceHTMLPreviewLeaveSection.js